import PartnerPage from "@/views/partner/PartnerPage.vue";
import Course from "@/views/partner/children/course/Course.vue";
import PartnerProfile from "@/views/partner/children/profile/Profile";
import CourseIndex from "@/views/partner/children/course/CourseIndex";
import Dashboard from "@/views/partner/children/dashboard/Dashboard.vue";
import PartnerClasses from "@/views/partner/children/classes/PartnerClasses";
import PartnerCalendar from "@/views/partner/children/calendar/Calendar.vue";
import CourseContent from "@/views/partner/children/course/CourseContent.vue";
import PartnerLeasonsForm from "@/views/partner/children/classes/leasons/leasons.vue";
import NotificationsArea from "@/views/partner/children/notifications/NotificationsArea";
import PartnerClassesForm from "@/views/partner/children/classes/form/PartnerClassesForm";

const prefix = "/connect/professor";

export const partner_routes = [
  {
    path: prefix,
    name: "Bem-vindo",
    component: PartnerPage,
    meta: { authRequired: true, preventAuth: true },
    children: [
      {
        path: `${prefix}/cockpit`,
        name: "Meu progresso",
        component: Dashboard,
        meta: { authRequired: true, preventAuth: true },
      },
      {
        path: `${prefix}/perfil`,
        name: "Perfil",
        component: PartnerProfile,
        meta: { authRequired: true, preventAuth: true },
      },
      {
        path: `${prefix}/turmas`,
        name: "Turmas",
        component: PartnerClasses,
        meta: { authRequired: true, preventAuth: true },
      },
      {
        path: `${prefix}/turmas/:id`,
        name: "Gerenciar Turma",
        component: PartnerClassesForm,
        meta: { authRequired: true, preventAuth: true },
      },
      {
        path: `${prefix}/aulas`,
        name: "Aulas",
        component: PartnerLeasonsForm,
        meta: { authRequired: true, preventAuth: true },
      },
      {
        path: `${prefix}/aulas/:id`,
        name: "Gerenciar aula",
        component: PartnerClasses,
        meta: { authRequired: true, preventAuth: true },
      },
      {
        path: `${prefix}/notificacoes`,
        name: "Minhas Notificações",
        component: NotificationsArea,
        meta: { authRequired: true, preventAuth: true },
      },
      {
        path: `${prefix}/curso`,
        name: "O Curso",
        component: CourseIndex,
        meta: { authRequired: true, preventAuth: true },
      },
      {
        path: `${prefix}/curso/:id`,
        name: "Aulas",
        component: Course,
        meta: { authRequired: true, preventAuth: true },
      },
      {
        path: `${prefix}/curso/:module/:id`,
        name: "Conteúdo",
        component: CourseContent,
        meta: { authRequired: true, preventAuth: true },
      },
      {
        path: `${prefix}/agenda`,
        name: "Agenda",
        component: PartnerCalendar,
        meta: { authRequired: true, preventAuth: true },
      },
    ],
  },
];
